import { ConfirmationModal, Loader } from 'components';
import { useLogout, useToast } from 'hooks';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Routes } from 'router';

/**
 * Interface for logout response
 */
export interface LogoutResponse {
  detail: string;
}

const Signout = ({ show, close }: { show: boolean; close: () => void }) => {
  // Hooks
  const { openToast } = useToast();
  const navigate = useNavigate();
  const { mutate: logout, isSuccess, isPending, error, reset } = useLogout();

  useEffect(() => {
    if (isSuccess) {
      navigate(Routes.signin);
      localStorage.setItem('logout', 'true');
      reset();
    }
  }, [isSuccess, navigate, reset]);

  useEffect(() => {
    if (error) {
      const errorMessage =
        (error as any)?.response?.data?.message ||
        (error as any)?.response?.data?.error?.message ||
        'Failed to logout, please try again later';
      openToast({
        show: true,
        heading: 'Logout Error',
        text: errorMessage,
        type: 'error',
        timeOut: 2500,
      });
      reset();
    }
  }, [error, openToast, reset]);

  return (
    <>
      <Loader loading={isPending} />
      <ConfirmationModal
        show={show}
        close={close}
        handleContinue={logout}
        title={'Logout'}
        text={'Are you sure you want to logout?'}
        isRed
      />
    </>
  );
};

export { Signout };